import React from 'react';
import { PhoneFieldProps } from '../models';
import TextField from './TextField';

export const getPhoneError = (value: string) => {
  const isValid = value.match(/\([1-9]{1}\d{2}\) \d{3}-\d{4}/);
  return Boolean(isValid) ? false : 'Please enter a valid phone number.';
};

const PhoneField: React.FC<PhoneFieldProps> = (props) => (
  <TextField
    name="phone"
    type="tel"
    {...props}
    getFieldError={getPhoneError}
    maskOptions={{
      mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      guide: false,
    }}
  />
);

export default PhoneField;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/forms/fields/PhoneField.tsx